import React from 'react'
import Fragment from '../common/fragment'


function FragmentCV(props) {
  return (
    <Fragment pos="vvv" {...props}>
      <p>
En el ex Convento, un coro de niños. Sonidos secuenciales: inspiración y
expiración. Un verbo para los pulmones y la garganta, que sopla aquello que nunca
podríamos decir. Los niños juegan con al aire, salen corriendo entre la brisa y otras
manifestaciones del viento. Tocan las flautas y llaman a los espíritus, entre muros y
puertas, entre palmeras y palomas impenitentes. El agua cristalina que sale de las
llaves y que corre entre las manos, aire transparente que se disipa en el cielo, las
golondrinas y también abejorros. Coros de otras especies, cantos de vidas invisibles.
Oratorios terrestres y alegría solar de los infantes.
      </p>
    </Fragment>
  )
}


export default FragmentCV
